export const LEAD_COLUMNS = [
  { key: 'warming_up', label: 'Warming Up', color: '#a78bfa' },
  { key: 'ready_to_call', label: 'Ready to Call', color: '#818cf8' },
  { key: 'called', label: 'Called', color: '#60a5fa' },
  { key: 'discovery', label: 'Discovery', color: '#38bdf8' },
  { key: 'demo', label: 'Demo', color: '#34d399' },
  { key: 'commercials', label: 'Commercials', color: '#eab308' },
  { key: 'onboarding', label: 'Onboarding', color: '#f59e0b' },
  { key: 'onboarded', label: 'Onboarded', color: '#10b981' },
  { key: 'ghosted', label: 'Ghosted', color: '#94a3b8' },
  { key: 'uninterested', label: 'Uninterested', color: '#f87171' },
  { key: 'lost', label: 'Lost', color: '#ef4444' }
];
